"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Dropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Popper = _interopRequireDefault(require("@mui/material/Popper"));
var _Fade = _interopRequireDefault(require("@mui/material/Fade"));
var _js = _interopRequireDefault(require("@quintoandar/cozy-theme/tokens/js"));
var _DropdownContent = _interopRequireDefault(require("./DropdownContent"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var styles = {
  "popper": "h8Mcug"
};
var Dropdown = exports.Dropdown = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
    triggerComponent = _ref.triggerComponent,
    placement = _ref.placement,
    openWithClick = _ref.openWithClick,
    role = _ref.role,
    tabIndex = _ref.tabIndex,
    onDropdownOpen = _ref.onDropdownOpen,
    contentPaddingTop = _ref.contentPaddingTop,
    disablePortal = _ref.disablePortal,
    fixedWidth = _ref.fixedWidth,
    closeOnExpandedAreaClick = _ref.closeOnExpandedAreaClick,
    keepMounted = _ref.keepMounted,
    _ref$isOpen = _ref.isOpen,
    isExternalOpen = _ref$isOpen === void 0 ? false : _ref$isOpen;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    openedByClick = _useState4[0],
    setOpenedByClick = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isMouseOver = _useState6[0],
    setIsMouseOver = _useState6[1];
  var timeoutId = (0, _react.useRef)(false);
  var openTimeoutId = (0, _react.useRef)(false);
  var isOpen = openedByClick || isMouseOver || isExternalOpen;
  (0, _react.useEffect)(function () {
    return function () {
      clearTimeout(timeoutId.current);
      clearTimeout(openTimeoutId.current);
    };
  }, []);
  var toggleByClick = (0, _react.useCallback)(function (event) {
    if (!isMouseOver) {
      if (event.currentTarget) {
        setAnchorEl(event.currentTarget);
      }
      clearTimeout(openTimeoutId.current);
      openTimeoutId.current = setTimeout(function () {
        return setOpenedByClick(function (prev) {
          return !prev;
        });
      });
    }
  }, [isMouseOver, setAnchorEl, setOpenedByClick]);
  var closeDropDown = (0, _react.useCallback)(function () {
    setOpenedByClick(false);
    setIsMouseOver(false);
  }, [setOpenedByClick, setIsMouseOver]);
  var onTriggerEnter = (0, _react.useCallback)(function (event) {
    clearTimeout(timeoutId.current);
    if (event.currentTarget) {
      setAnchorEl(event.currentTarget);
    }
    setIsMouseOver(true);
  }, [timeoutId, setAnchorEl, setIsMouseOver]);
  var onContentEnter = (0, _react.useCallback)(function () {
    clearTimeout(timeoutId.current);
    setIsMouseOver(true);
  }, [timeoutId, setIsMouseOver]);
  var onContentLeave = (0, _react.useCallback)(function () {
    timeoutId.current = setTimeout(function () {
      setIsMouseOver(false);
    }, 500);
  }, [timeoutId, setIsMouseOver]);
  var onTriggerClick = (0, _react.useCallback)(function (event, isOpen) {
    if (!isOpen) {
      toggleByClick(event);
    }
    if (triggerComponent.props.onClick) {
      triggerComponent.props.onClick(event);
    }
  }, [toggleByClick, triggerComponent]);
  var onTriggerKeyDown = (0, _react.useCallback)(function (event) {
    if (['ArrowDown'].includes(event.key) && !isOpen) {
      event.preventDefault();
      toggleByClick(event);
    }
  }, [isOpen, toggleByClick]);
  var defaultProps = {
    'aria-haspopup': true,
    'aria-expanded': isOpen,
    ref: ref,
    role: role,
    tabIndex: tabIndex,
    isDropdownOpen: isOpen,
    onClick: function onClick(event) {
      return onTriggerClick(event, isOpen);
    },
    onKeyDown: onTriggerKeyDown
  };
  var hoverTriggerProps = _objectSpread(_objectSpread({}, defaultProps), {}, {
    onMouseEnter: onTriggerEnter,
    onMouseLeave: onContentLeave
  });
  var triggerElement = /*#__PURE__*/(0, _react.cloneElement)(triggerComponent, openWithClick ? defaultProps : hoverTriggerProps);
  var Content = /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_DropdownContent["default"], {
    fixedWidth: fixedWidth,
    isOpen: isOpen,
    openWithClick: openWithClick,
    closeDropDown: closeDropDown,
    onContentEnter: onContentEnter,
    onContentLeave: onContentLeave,
    onDropdownOpen: onDropdownOpen,
    paddingTop: contentPaddingTop,
    isExternalOpen: isExternalOpen,
    closeOnExpandedAreaClick: closeOnExpandedAreaClick
  }, children));
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, triggerElement, /*#__PURE__*/_react["default"].createElement(_Popper["default"], {
    "data-dropdown-popper": true,
    open: isOpen,
    anchorEl: anchorEl,
    placement: placement,
    transition: !keepMounted,
    keepMounted: keepMounted,
    disablePortal: disablePortal,
    className: styles.popper
  }, keepMounted ? Content : function (_ref2) {
    var TransitionProps = _ref2.TransitionProps;
    return /*#__PURE__*/_react["default"].createElement(_Fade["default"], _extends({}, TransitionProps, {
      timeout: 300
    }), Content);
  }));
});
Dropdown.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node.isRequired,
  triggerComponent: _propTypes["default"].node.isRequired,
  placement: _propTypes["default"].oneOf(['bottom-end', 'bottom-start', 'bottom', 'right-start']),
  openWithClick: _propTypes["default"].bool,
  role: _propTypes["default"].string,
  tabIndex: _propTypes["default"].number,
  onDropdownOpen: _propTypes["default"].func,
  contentPaddingTop: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  disablePortal: _propTypes["default"].bool,
  fixedWidth: _propTypes["default"].bool,
  closeOnExpandedAreaClick: _propTypes["default"].bool,
  keepMounted: _propTypes["default"].bool,
  isOpen: _propTypes["default"].bool
} : {};
Dropdown.defaultProps = {
  placement: 'bottom-start',
  openWithClick: false,
  disablePortal: true,
  closeOnExpandedAreaClick: true,
  keepMounted: false,
  isOpen: false
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Dropdown);